import * as React from 'react';
import Navigation from './Navigation';
import '../../sass/Authentication.css';
import Spinner from 'react-spinkit';
import { Fade } from 'react-bootstrap';
// import { firebase } from '../../firebase';
import { db, auth } from '../../firebase/firebase';
import AppConfig from '../../config/AppConfig';
import Logo from '../Logo';
import AppUtils from '../../utils/AppUtils';
import Settings from 'src/objects/Settings';

const _global = (window) as any;

class LandingPage extends React.Component<any,any> {

  private usersDatabaseRef:firebase.database.Reference = db.app.database().ref("users");
  private textDatabaseRef:firebase.database.Reference = db.app.database().ref('text');
  private settingsDatabaseRef:firebase.database.Reference = db.app.database().ref('settings');

  constructor(props:any) {
    super(props);
 
    AppUtils.isMobile = window.innerWidth <= AppConfig.MOBILE_WIDTH;
    
    this.onUserDataLoaded = this.onUserDataLoaded.bind(this);
    this.preloadGame = this.preloadGame.bind(this);

    this.state = {
      userSessionLoaded: false,
      text: null,
      settings: null,
      userData: null,
    }
    
    this.onTextLoaded = this.onTextLoaded.bind(this);
    this.onSettingsLoaded = this.onSettingsLoaded.bind(this);

    this.textDatabaseRef.on('value', this.onTextLoaded);
    this.settingsDatabaseRef.on('value', this.onSettingsLoaded);

    auth.onAuthStateChanged(authUser => {
      if (authUser) {
        this.usersDatabaseRef.child(authUser.uid).once('value', this.onUserDataLoaded);
      } else {
        this.setState({userSessionLoaded: true});
      }
    });
  }

  private onTextLoaded(e:any):void {
    if (e.val() == null) {
      // set default
      this.textDatabaseRef.set(AppConfig.text)
    } else {
      this.setState({text: e.val()});
    }
  }

  private onSettingsLoaded(e:any):void {
    if (e.val() == null) {
      // set default
      this.settingsDatabaseRef.set(new Settings())
    } else {
      this.setState({settings: e.val()});
    }
    this.preloadGame();
  }

  private preloadGame():void {
    if (AppConfig.gameLoaded == false) {
      if (_global.preloadGame != null) {
        AppConfig.gameLoaded = true;
        console.log("[Landing] Loading theme:", this.state.settings.theme)
        _global.preloadGame(this.state.settings.theme);
      } else {
        console.log("[Landing] Game not loaded. Trying again.")
        setTimeout(this.preloadGame, 500);
      }
    }
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    if (this.usersDatabaseRef != null) {
      this.usersDatabaseRef.off();
      this.textDatabaseRef.off();
      this.settingsDatabaseRef.off();
    }
  }

  private onUserDataLoaded(e:any) {
    AppConfig.userData = e.val();
    this.setState({userSessionLoaded: true, userData:e.val()});
  }
  
  render() {
    return (
      <div id='landingPageContainer'>
        <Logo/>
        <Fade in={!this.state.userSessionLoaded && this.state.text != null} timeout={1000} unmountOnExit={true}>
          <div id="loadingOverlay">
            <Spinner name="folding-cube" color="aqua"/>
          </div>
        </Fade>
        {
          this.state.userSessionLoaded && this.state.text != null ?
          <div id='panel' className='authModal'>
            <div>
              <p><i>{this.state.text.landing.subHeading}</i></p>
              <h2>{this.state.text.landing.title}</h2>
              <p>{this.state.text.landing.description}</p>
              <Navigation />
            </div>
          </div> : null
        }
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/routes/Landing.tsx